
/************************* Helpers *************************/
const root = document.getElementsByTagName('html')[0];

let drawerOverlayLoaded = false;

const createDrawerOverlay = () => {
  const overlay = document.createElement('div');
  overlay.classList.add('g-drawer-overlay')
  document.body.append(overlay)

  drawerOverlayLoaded = true;
}

let modalOverlayLoaded = false;

const createModalOverlay = () => {
  const overlay = document.createElement('div');
  overlay.classList.add('g-modal-overlay')
  document.body.append(overlay)

  modalOverlayLoaded = true;
}


const createElementFromHTML = (htmlString) => {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstElementChild;
};

const getPageContentHtml = async (url) => {
  try {
    const pageJson = await (
      await fetch(url + '.json')
        .then(res => res.json()));
    return pageJson.page.body_html;
  } catch (error) {
    console.log('Error: ', error);
    return '';
  }
}

const compareArrays = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

const browserName = (function(agent) {
  switch (true) {
    case agent.indexOf("edge") > -1: return "MS Edge";
    case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
    case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
    case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
    case agent.indexOf("trident") > -1: return "MS IE";
    case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
    case agent.indexOf("safari") > -1: return "Safari";
    default: return "other";
  }
})(window.navigator.userAgent.toLowerCase());


/************************* Open cart drawer  *************************/
(async function() {
  // Get the query string from the URL
  const queryString = window.location.search;
  // Create a URLSearchParams object from the query string
  const urlParams = new URLSearchParams(queryString);

  // Check if the URL has a parameter named cartDrawer
  if (urlParams.has("cartDrawer")) {
    // Get the value of the parameter
    const cartDrawerValue = urlParams.get("cartDrawer");

    // Do something if the value is "open"
    if (cartDrawerValue === "open") {

      // Open cart drawer
      document.dispatchEvent(new CustomEvent("cartDrawer:open", { bubbles: true }));

      const url = new URL(window.location.href);
      // Get the parameters from the URL
      const params = url.searchParams;
      // Delete the parameter you want to remove
      params.delete("cartDrawer");
      // Update the URL with the new parameters
      window.history.replaceState({}, "", url);
    }
  }
})()

/************************* Custom Complimantary products in cart drawer *************************/
/**
 * Converts htmlString into nodeElement
 * @param {string} htmlString
 * @returns
 */

let cartProductIdArray = [];

const getCartComplimentary = async ({ cart }) => {
  const cartComplementarySection = document.querySelector('.cart-complementary');
  const section = document.querySelector(
    '.product-info__complementary-products'
  );

  if (!cartComplementarySection || !section) return

  const productContainer = section.querySelector('.horizontal-product-list');
  if (!section || !productContainer) return;
  const url = cartComplementarySection.dataset.url;
  const limit = Number(cartComplementarySection.dataset.limit)
  const urls = [];
  let productsArr = [];

  if (cart === null) {
    cart = await (await fetch(`${ Shopify.routes.root }cart.js`)).json();
  }

  const products_id = cart.items.map((x) => x.product_id);

  //If there is no change in the products, abort.
  if (compareArrays(cartProductIdArray, products_id)) return;

  //Save the products currently in cart.
  cartProductIdArray = products_id


  /**
  * Reversing the array, so the first product added complimentary products get shown first
  */
  products_id.reverse();

  products_id.forEach((id) => {
    urls.push(url.replace('[product_id]', id));
  });

  let productCount = 0;

  // Getting array of complementary products
  await Promise.all(
    urls.map((url) =>
      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          json.products.forEach(product => {
            if (limit === 0 || productCount < limit) {
              productsArr.push(product);
              productCount++;
            } else {
              return
            }
          });
        })
        .catch((e) => {
          console.error(e);
        })
    )
  );

  // Uniqify array of complementary products
  const uniqueProductsArr = Array.from(
    new Set(productsArr.map((a) => a.id))
  ).map((id) => {
    return productsArr.find((a) => a.id === id);
  });

  if (productsArr.length <= 0) {
    section.hidden = true;
    return;
  }


  let complimentaryProductObjArray = [];

  // Getting html for array of complementary products
  await Promise.all(
    uniqueProductsArr.map((product) =>
      fetch(`/products/${ product.handle }?view=cart-complimentary`)
        .then((data) => {
          return data.text();
        })
        .then((htmlText) => {

          const complimentaryProductObj = {};
          complimentaryProductObj.id = product.id;
          complimentaryProductObj.html = htmlText;
          complimentaryProductObjArray.push(complimentaryProductObj);

        })
    )
  );

  const uniqueProductsIdArr = uniqueProductsArr.map(product => product.id);

  complimentaryProductObjArray.sort(function(a, b) {
    return uniqueProductsIdArr.indexOf(a.id) - uniqueProductsIdArr.indexOf(b.id);
  });

  let newProductsString = '';
  complimentaryProductObjArray.forEach(complimentaryProductObj => {
    newProductsString += complimentaryProductObj.html;
  });

  productContainer.innerHTML = null;
  productContainer.insertAdjacentHTML('beforeend', newProductsString);
  section.hidden = false;
};

(async function() {
  // Get the element with id cart-drawer
  const cartDrawer = document.getElementById("cart-drawer");


  // Define a callback function to handle the mutation events
  const handleCartDrawerMutation = async (mutations) => {
    // Loop through the mutations array
    for (const mutation of mutations) {
      // Check if the mutation type is attribute
      if (mutation.type === "attributes") {
        // Check if the attribute name is open
        if (mutation.attributeName === "open") {
          // Get the current value of the open attribute
          const hasOpen = cartDrawer.hasAttribute("open");
          // Do something based on the open value
          if (hasOpen) {

            // Do something when the element is open
            await getCartComplimentary({ cart: null });

            document.addEventListener('cart:change', async (event) => {
              await getCartComplimentary({ cart: event.detail.cart });
            });

            cartDrawerObserver.disconnect()
          }
        }
      }
    }
  };

  // Create a new mutation observer with the callback function
  const cartDrawerObserver = new MutationObserver(handleCartDrawerMutation);
  // Start observing the cart drawer element for attribute changes
  cartDrawerObserver.observe(cartDrawer, { attributes: true });

  document.addEventListener("DOMContentLoaded", () => {
    if (cartDrawer.hasAttribute('open')) {
      getCartComplimentary({ cart: null });
    }
  });


})();

/************************* Linked products *************************/
class LinkedProductsModal {
  constructor({ main }) {
    this.main = main,
      this.image = main.querySelector('.linked-products-modal__image-render'),
      this.infoTitle = main.querySelector('.linked-products-modal__info-title'),
      this.infoPrice = main.querySelector('.linked-products-modal__info-price'),
      this.infoButton = main.querySelector('.linked-products-modal__info-button'),
      this.init();

    this.Keydown = this.Keydown.bind(this);

  }

  init() {
    this.eventListeners();
  }

  ModalEventListeners() {
    document.addEventListener("keydown", this.Keydown, false);

  }
  RemoveModalEventListeners() {
    document.removeEventListener("keydown", this.Keydown, false);
  }

  Keydown(event) {
    if (event.keyCode !== 27) return;
    this.toggleModal();
  }

  eventListeners() {
    this.main.addEventListener('click', (event) => {
      if (!this.main.classList.contains('open')) {
        return;
      }

      const target = event.target;
      if (
        target.tagName === 'A' &&
        target.classList.contains('linked-product__link')
      ) {
        event.preventDefault();
        this.changeVisibleProduct(target);
      }
    });


    this.ObserveImageContainer()

  }

  ObserveImageContainer() {
    // Define a callback function to handle the mutations
    const callback = (mutations) => {
      // Loop through the mutations
      for (const mutation of mutations) {
        // Check if the mutation type is childList
        if (mutation.type === "childList") {
          // Loop through the added nodes
          for (const node of mutation.addedNodes) {
            // Do something with the new node
            if (node.tagName === "IMG") {
              // Add an onload event listener to the node
              node.onload = () => {
                while (this.image.childNodes.length > 1) {
                  this.image.removeChild(this.image.firstChild);
                }
              };
            }
          }
        }
      }
    };

    // Create a new MutationObserver instance and pass the callback function
    const observer = new MutationObserver(callback);

    // Define the options for the observer
    const options = {
      childList: true, // Observe child elements
      subtree: true, // Observe descendants
    };

    // Start observing the target element with the options
    observer.observe(this.image, options);
  }

  changeVisibleProduct(target) {
    const productItemContainer = target.closest(
      '.linked-products-modal__product'
    );
    const template = productItemContainer.querySelector('template');

    const productItems = productItemContainer.parentElement.querySelectorAll('.linked-products-modal__product');

    productItems.forEach(element => {
      element.classList.remove('active')
    });
    productItemContainer.classList.add('active')


    const dataUrl = template.dataset.url;
    const dataTitle = template.dataset.title;
    const dataImage = template.content.querySelector('[data-image] > *').cloneNode(true);
    const dataPrice = template.content.querySelector('[data-price] > *').cloneNode(true);

    if (dataTitle) {
      this.infoTitle.innerText = dataTitle;
    }

    if (dataUrl) {
      this.infoButton.href = dataUrl;
    }

    if (dataImage) {
      this.image.appendChild(dataImage);
    }
    else {
      this.image.replaceChildren()
    }

    if (dataPrice) {
      this.infoPrice.replaceChildren(dataPrice);
    }
    else {
      this.image.replaceChildren()
    }
  }

  toggleModal() {
    this.main.classList.toggle('open');
    if (this.main.classList.contains('open')) {
      root.classList.add('lock');
      this.ModalEventListeners();
    }
    else {
      root.classList.remove('lock');
      this.RemoveModalEventListeners();
    }
  }
}


(async function() {

  const linkedProductTiggers = document.querySelectorAll(
    '[data-linked-products_modal=toggle]'
  );

  const linkedProductModalElem = document.querySelector('.linked-products-modal');

  if (linkedProductModalElem) {
    const linkedProductModal = new LinkedProductsModal({
      main: linkedProductModalElem,
    });
    linkedProductTiggers.forEach((linkedProductTigger) => {
      linkedProductTigger.addEventListener('click', () => {
        linkedProductModal.toggleModal();
      });
    });
  }
})();


/************************* ESTIMATED DELIVERY *************************/

const daysInBetween = (date1, date2) => {
  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24;

  // Calculating the time difference between two dates
  const diffInTime = date2.getTime() - date1.getTime();

  // Calculating the no. of days between two dates
  const diffInDays = Math.round(diffInTime / oneDay);

  return diffInDays;
}

let setEstimatedDelivery = function() {
  const estimatedDeliveryElement = document.querySelectorAll('[data-estimated-delivery]')
  let deliveryDays = []

  for (const key in window.themeVariables.estimatedDelivery.days) {
    deliveryDays.push(window.themeVariables.estimatedDelivery.days[key])
  }

  const getEstimatedDeliveryDay = ({ element, today, days, maxDays }) => {
    const todayDeadlineTime = deliveryDays[today.getDay()].split(':')
    const todaysDeadline = new Date().setHours(todayDeadlineTime[0], todayDeadlineTime[1])
    let newDate = new Date()

    if (today.getTime() > todaysDeadline) {
      newDate.setDate(newDate.getDate() + 1)
    }

    if (!deliveryDays || !deliveryDays.length || deliveryDays.every(day => !day.trim())) {
      return;
    }

    let i = 0
    if (Number(days) && Number(days) > 0) {
      while (i < days) {
        if (deliveryDays[newDate.getDay()] != '') {
          newDate.setDate(newDate.getDate() + 1)
          i++
        } else {
          newDate.setDate(newDate.getDate() + 1)
        }
      }
    }

    // if weekend
    if (newDate.getDay() == 6) {
      // if newDate is saturday, add 2 days to delivery
      newDate.setDate(newDate.getDate() + 2)
    } else if (newDate.getDay() == 0) {
      // if newDate is sunday, add 1 days to delivery
      newDate.setDate(newDate.getDate() + 1)
    }

    const totalEstimatedDeliveryDays = daysInBetween(today, newDate);

    if (totalEstimatedDeliveryDays > maxDays) {
      return element.closest('.estimated-delivery')?.remove();
    }

    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return newDate.toLocaleDateString(window.themeVariables.estimatedDelivery.localeFormat, options)
  }


  

  estimatedDeliveryElement.forEach((element) => {

    const estimatedDeliveryDay = getEstimatedDeliveryDay({
      element,
      today: new Date(),
      days: parseInt(window.themeVariables.estimatedDelivery.deliveryTime),
      maxDays: parseInt(window.themeVariables.estimatedDelivery.maxDeliveryTime)
    })

    if (element.tagName === "INPUT") {
      element.value = estimatedDeliveryDay;
    } else {
      element.innerHTML = estimatedDeliveryDay;
    }

    // Check if estimatedDeliveryDay is valid data, else destroy
    if (!estimatedDeliveryDay) {
      element.closest('.estimated-delivery')?.remove();
    }
  })


};

(async function() {
  await setEstimatedDelivery();
})();
document.addEventListener('cart:change', (event) => {
  setEstimatedDelivery();
});


/************************* Trust testimonials - Drawer *************************/

let trustWidgetModalRendered = false;

class TrustWidgetDrawer {
  constructor({ openers }) {
    this.openers = openers,
      this.settings = {};

    this.Click = this.Click.bind(this);
    this.Keydown = this.Keydown.bind(this);

    this.Init();
  }

  Init() {
    this.EventListeners();
  }

  EventListeners() {
    this.openers.forEach(opener => {
      opener.addEventListener('click', () => {

        if (trustWidgetModalRendered === true) {
          this.OpenDrawer();
        } else {
          this.CreateDrawer();
        }
      });

    });
  }

  DrawerEventListeners() {
    document.addEventListener('click', this.Click, false);
    document.addEventListener("keydown", this.Keydown, false);
  }
  RemoveDrawerEventListeners() {
    document.removeEventListener('click', this.Click, false);
    document.removeEventListener("keydown", this.Keydown, false);
  }

  Click(event) {
    if (!this.drawer.classList.contains('open')) return
    const target = event.target;

    if (!this.drawer.contains(target) || target.hasAttribute('data-drawer-close')) {
      this.CloseDrawer();
    }
  }

  Keydown(event) {
    if (event.keyCode !== 27) return;
    this.CloseDrawer();
  }


  OpenDrawer() {
    this.drawer.classList.add('open');
    document.body.classList.add('g-drawer-open', 'lock');
    setTimeout(() => {
      this.DrawerEventListeners();
    }, 0);
  }
  CloseDrawer() {
    this.drawer.classList.remove('open');
    document.body.classList.remove('g-drawer-open', 'lock');
    setTimeout(() => {
      this.RemoveDrawerEventListeners();
    }, 0);
  }

  async CreateDrawer() {

    const drawer = await this.GetTestimonials();

    if (!drawerOverlayLoaded) {
      createDrawerOverlay();
    }

    document.body.append(drawer);

    trustWidgetModalRendered = true;

    this.drawer = drawer;

    setTimeout(() => {
      this.DrawerEventListeners();
      this.OpenDrawer();
    }, 50);

  }

  async GetTestimonials() {
    const trustTestimonials = await (
      await fetch(window.Shopify.routes.root + "?sections=trust-testimonial-data")
        .then(res => res.json()));


    const htmlString = trustTestimonials['trust-testimonial-data'];

    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    const body = html.body;

    return body.querySelector('.g-drawer');

  }

}

(async function() {

  const trustWidgetDrawerOpeners = document.querySelectorAll('[data-trust-reviews-open]');

  if (trustWidgetDrawerOpeners.length > 0) {
    new TrustWidgetDrawer({ openers: trustWidgetDrawerOpeners });
  }
})();

/************************* G Drawer *************************/
class GDrawer {
  constructor({ trigger }) {
    this.trigger = trigger
    this.settings = {
      title: trigger.dataset.title,
      url: trigger.dataset.url,
      drawerRendered: false
    };

    this.Click = this.Click.bind(this);
    this.Keydown = this.Keydown.bind(this)

    this.Init();
  }

  Init() {
    this.EventListeners();
  }

  EventListeners() {

    this.trigger.addEventListener('click', () => {

      if (this.settings.drawerRendered === true) {
        this.OpenDrawer();
      } else {
        this.CreateDrawer();
      }
    });

  }

  DrawerEventListeners() {
    document.addEventListener('click', this.Click, false);
    document.addEventListener("keydown", this.Keydown, false);
  }
  RemoveDrawerEventListeners() {
    document.removeEventListener('click', this.Click, false);
    document.removeEventListener("keydown", this.Keydown, false);
  }

  Click(event) {
    if (!this.drawer.classList.contains('open')) return
    const target = event.target;

    if (!this.drawer.contains(target) || target.hasAttribute('data-drawer-close')) {
      this.CloseDrawer();
    }
  }

  Keydown(event) {

    if (event.keyCode !== 27) return;
    this.CloseDrawer();
  }

  OpenDrawer() {
    this.drawer.classList.add('open');
    document.body.classList.add('g-drawer-open');
    setTimeout(() => {
      this.DrawerEventListeners();
    }, 0);
  }
  CloseDrawer() {
    this.drawer.classList.remove('open');
    document.body.classList.remove('g-drawer-open');
    setTimeout(() => {
      this.RemoveDrawerEventListeners();
    }, 0);
  }

  async CreateDrawer() {

    const pageContent = await getPageContentHtml(this.settings.url);
    const htmlString = `<aside class="g-drawer">
  <div class="g-drawer__container">
    <div class="g-drawer__inner c-scroll">
      <header class="g-drawer__header">
        <div class="g-drawer__header-wrap">
          <h4 class="h5">${ this.settings.title }</h4>
          <button
            name="Close"
            class="g-drawer__button"
            data-drawer-close
            type="button"
          >
            <svg
              role="presentation"
              stroke-width="2"
              focusable="false"
              width="19"
              height="19"
              class="icon icon-close"
              viewBox="0 0 24 24"
            >
              <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
            </svg>
          </button>
        </div>
      </header>

     <div class="g-drawer__content prose">
        ${ pageContent }
     </div>
    </div>
  </div>
</aside>`;

    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    const drawerHtml = html.body.firstElementChild;

    drawerHtml.querySelector('.g-drawer__content')

    if (!drawerOverlayLoaded) {
      createDrawerOverlay();
    }

    document.body.append(drawerHtml);
    this.settings.drawerRendered = true

    this.drawer = drawerHtml;

    this.trigger.setAttribute('loaded', 'true');

    setTimeout(() => {
      this.DrawerEventListeners();
      this.OpenDrawer();
    }, 50);

  }

}


const initGDrawers = async () => {
  const gDrawerTriggers = document.querySelectorAll('[data-g-drawer]:not([data-loaded])');

  gDrawerTriggers.forEach(gDrawerTrigger => {
    new GDrawer({ trigger: gDrawerTrigger });
  });

}

initGDrawers();

/* This closes the quick add, if it opens the cart drawer */
const closeQuickBuyDrawerOnCartDrawerOpen = async (event) => {
  const item = event.detail.hasOwnProperty('item') ? event.detail.item : null;
  if (!item) return
  var click = (event) => {
    const target = event.target;
    if (item.contains(target)) {
      if (target.hasAttribute('aria-controls') && target.getAttribute('aria-controls') === 'cart-drawer') {
        item.removeAttribute('open');
        item.removeEventListener('click', click);
      }
    } else {
      item.removeEventListener('click', click);
    }
  }
  click = click.bind(item);
  item.addEventListener('click', click);
}

// document.addEventListener('quickBuyDrawer:loaded', initGDrawers)
document.addEventListener('quickBuyDrawer:loaded', closeQuickBuyDrawerOnCartDrawerOpen)


/************************* Klviyo - Newsletter form *************************/


class KlaviyoForm {
  constructor({ main }) {

    this.main = main;
    this.submitButton = main.querySelector('button[type=submit]');

    this.listId = main.dataset.listId
    this.companyId = main.dataset.companyId

    this.attributes = {
      first_name: '',
      last_name: '',
      email: "",
      properties: {}
    }

    this.Init();
  }

  Init() {
    this.Listeners();

    if (this.submitButton) {
      this.submitButton.disabled = false
    }
  }

  Listeners() {
    this.main.addEventListener('submit', (event) => {
      event.preventDefault();
      this.GetFormData({ form: event.target });
      this.Submit();
    })
  }

  async GetFormData({ form }) {
    const formData = new FormData(form);

    this.attributes.properties['page'] = window.location.href;
    this.attributes.properties['browser'] = browserName;
    this.attributes.properties['$consent'] = ["email"];

    for (var pair of formData.entries()) {

      switch (pair[0]) {
        case 'name':
          const nameArray = pair[1].split(' ');

          if (nameArray.length > 0) {
            this.attributes.properties['first_name'] = nameArray[0];
          }

          if (nameArray.length > 1) {
            nameArray.shift();
            this.attributes.properties['last_name'] = nameArray.join(' ');
          }
          break;

        case 'email':
          this.attributes[pair[0]] = pair[1];
          break;

        case 'accepts_marketing':
          break;

        default:
          this.attributes.properties[pair[0]] = pair[1];
          break;
      }

    }
  }

  Success() {

    this.submitButton.ariaBusy = false;
    const parentContainer = this.main.parentElement
    const successContainer = document.createElement('div');
    successContainer.classList.add('fade-in-up');

    successContainer.innerHTML = window.themeVariables.strings.newsletterSuccess

    this.main.remove();
    parentContainer.insertAdjacentElement('afterBegin', successContainer);

    setTimeout(() => {
      parentContainer.classList.add('animate');
    }, 0);
  }

  FormReset(response) {
    this.submitButton.ariaBusy = false;

    alert(window.themeVariables.strings.newsletterError)
  }

  async Submit() {
    const options = {
      method: 'POST',
      headers: { revision: '2023-02-22', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: this.listId,
            custom_source: 'Custom signup form',
            email: this.attributes.email,
            properties: this.attributes.properties
          }
        }
      })
    };

    const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${ this.companyId }`, options);
    const string = await response.text();
    const json = string === "" ? {} : JSON.parse(string);

    if (Object.keys(json).length === 0) {
      return this.Success();
    }
    else {
      return this.FormReset(json);
    }

  }
}

(async () => {
  const klaviyoForms = document.querySelectorAll('.js-klaviyo-form');
  klaviyoForms.forEach(klaviyoForm => {
    new KlaviyoForm({ main: klaviyoForm });
  });

})();


/************************* G Modal *************************/
class GModal {
  constructor({ trigger }) {
    this.trigger = trigger
    this.settings = {
      title: trigger.dataset.title,
      url: trigger.dataset.url,
      modalRendered: false
    };

    this.Click = this.Click.bind(this);
    this.Keydown = this.Keydown.bind(this);

    this.Init();
  }

  Init() {
    this.EventListeners();
  }

  EventListeners() {
    this.trigger.addEventListener('click', () => {
      if (this.settings.modalRendered === true) {
        this.OpenModal();
      } else {
        this.CreateModal();
      }
    });
  }

  ModalEventListeners() {
    document.addEventListener('click', this.Click, false);
    document.addEventListener("keydown", this.Keydown, false);

  }
  RemoveModalEventListeners() {
    document.removeEventListener('click', this.Click, false);
    document.removeEventListener("keydown", this.Keydown, false);
  }

  Click(event) {
    if (!this.modal.classList.contains('open')) return
    const target = event.target;

    if (!this.modal.contains(target) || target.hasAttribute('data-modal-close')) {
      this.CloseModal();
    }
  }

  Keydown(event) {
    if (event.keyCode !== 27) return;
    this.CloseModal();
  }

  OpenModal() {
    this.modal.classList.add('open');
    document.body.classList.add('g-modal-open', 'lock');
    setTimeout(() => {
      this.ModalEventListeners();
    }, 0);
  }
  CloseModal() {
    this.modal.classList.remove('open');
    document.body.classList.remove('g-modal-open', 'lock');
    setTimeout(() => {
      this.RemoveModalEventListeners();
    }, 0);
  }

  async CreateModal() {

    const pageContent = await this.settings.url ? getPageContentHtml(this.settings.url) : this.trigger.innerHTML;

    let headerHTML = '';

    if (this.settings.title) {
      headerHTML = `
      <h4 class="h6">${ this.settings.title }</h4>`;
    }

    const htmlString = `<aside class="g-modal">
      <header class="g-modal__header">
        ${ headerHTML }
        <button name="Close linked products modal" class="g-modal__button" data-modal-close type="button">
          <span>${ window.themeVariables.strings.close }</span>
          <svg enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <g fill="none">
            <rect x="-9" y="-9"></rect>
            <line x2="32" y1="16" y2="16" stroke="#fff" stroke-miterlimit="10" stroke-width="4"></line>
            <line x1="16" x2="16" y2="32" stroke="#fff" stroke-miterlimit="10" stroke-width="4"></line>
            </g>
          </svg>
        </button>
      </header>
      <hr>
      <div class="g-modal__container">${ pageContent }</div>
    </aside>`;

    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    const modalHtml = html.body.firstElementChild;

    modalHtml.querySelector('.g-modal__container')

    if (!modalOverlayLoaded) {
      createModalOverlay();
    }

    document.body.append(modalHtml);
    this.settings.modalRendered = true

    this.modal = modalHtml;

    this.trigger.setAttribute('loaded', 'true');

    setTimeout(() => {
      this.ModalEventListeners();
      this.OpenModal();
    }, 50);

  }

  async GetClonedContent() {
    const htmlString = await (
      await fetch(this.settings.url)
        .then(res => res.text()));

    return htmlString;
  }

}

const initGModals = async () => {
  const gModalTriggers = document.querySelectorAll('[data-g-modal]:not([data-loaded])');

  gModalTriggers.forEach(gModalTrigger => {
    new GModal({ trigger: gModalTrigger });
  });

}

(async function() {
  await initGModals();
})();


/************************* Terms *************************/
class TermsModal {
  constructor({ terms, termsCheck, submitButton, expandTermsText }) {
    this.main = terms;
    this.checkBox = termsCheck;
    this.submitButton = submitButton;
    this.pageContent = terms.querySelector('.terms__page-content-inner');

    this.expandTermsText = expandTermsText;

    this.settings = {
      textLoaded: false
    }

    this.Click = this.Click.bind(this);

    this.Init();
  }

  Init() {
    this.main.classList.add('init');
    this.Open();

    this.FullTermsText({ open: false });

    this.Eventlisteners();

    if (this.expandTermsText === true) {
      this.OpenAndExpand();
    }
  }

  Eventlisteners() {
    document.addEventListener('terms:modal:open', () => {
      this.Open();
    }, true);

    document.addEventListener('terms:modal:openAndExpanded', () => {
      this.OpenAndExpand();
    }, true);
  }


  Click(event) {
    if (event.target.classList.contains('terms-accept')) {
      this.checkBox.checked = true;

      if (this.submitButton) {
        setTimeout(() => {
          this.submitButton.click();
        }, 0);
      }

      this.Close();
    } else if (
      event.target.classList.contains('terms-decline') ||
      !this.main.contains(event.target)
    ) {
      this.Close();
    } else if (event.target.classList.contains('expanded-close')) {
      this.CloseText();
    }
  }

  FullTermsText({ open }) {
    if (this.main.hasAttribute('data-terms-page')) {
      const pageUrl = this.main.getAttribute('data-terms-page');
      const pageTitle = this.main.getAttribute('data-terms-page-title');

      if (pageUrl) {
        const termsTextLink = this.main.querySelector(
          `.terms__terms-text a[title='${ pageTitle }']`
        );
        if (termsTextLink) {
          termsTextLink.addEventListener('click', (event) => {
            event.preventDefault();

            if (this.pageContent.classList.contains('loaded')) {
              this.OpenText();
            } else {
              this.FetchFullTermsText(pageUrl);
            }
          });

          if (open) {
            if (this.pageContent.classList.contains('loaded')) {
              this.OpenText();
            } else {
              this.FetchFullTermsText(pageUrl);
            }
          }
        }
      }
    }
  }

  FetchFullTermsText(pageUrl) {
    return fetch(`${ pageUrl }?view=terms-content`)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        this.pageContent.insertAdjacentHTML('afterbegin', html);
        this.pageContent.classList.add('loaded');
        this.settings.textLoaded = true;
        this.OpenText();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  OpenText() {
    this.main.classList.add('expanded');
  }
  CloseText() {
    this.main.classList.remove('expanded');
  }

  Open() {
    this.main.classList.add('active');

    setTimeout(() => {
      document.addEventListener('click', this.Click);
    }, 0);
  }

  Close() {
    document.removeEventListener('click', this.Click);
    this.CloseText();
    this.main.classList.remove('active');
  }


  OpenAndExpand() {
    this.Open();
    if (this.settings.textLoaded) {
      this.OpenText();
    } else {
      this.FullTermsText({ open: true });
    }
  }

}

/************************* Inline Terms *************************/

class InlineTerms {
  constructor(inlineTerms) {
    this.main = inlineTerms;
    this.Init();
  }

  Init() {
    this.TermsTextClick();
  }

  TermsTextClick() {
    if (this.main.hasAttribute('data-terms-page')) {
      const pageUrl = this.main.getAttribute('data-terms-page');
      const pageTitle = this.main.getAttribute('data-terms-page-title');

      if (pageUrl) {
        const termsTextLink = this.main.querySelector(`.inline-terms__content a[title='${ pageTitle }']`);
        if (termsTextLink) {
          termsTextLink.addEventListener('click', (event) => {
            event.preventDefault();

            window.termsValidation(event, true);
          });
        }
      }
    }
  }
}

(async function() {
  const inlineTerms = document.querySelectorAll('.inline-terms');
  inlineTerms.forEach(inlineTermsItem => {
    new InlineTerms(inlineTermsItem);
  });
})();

window.termsValidation = async (event, expandTermsText = false) => {
  const validate = async () => {
    const termsCheck = document.getElementById('TermsCheck');
    const termsModal = document.getElementById('Terms');

    if (!termsModal && !termsCheck || (termsCheck.checked == true && !expandTermsText)) return;

    event.preventDefault();

    const submitButton = document.querySelector('[name="checkout"][type="submit"]');
    if (submitButton) {
      setTimeout(() => {
        submitButton.setAttribute('aria-busy', false);
      }, 0);
    }

    if (termsModal && !termsModal.classList.contains('init')) {
      new TermsModal({ terms: termsModal, termsCheck, submitButton: submitButton, expandTermsText });
    } else if (termsModal) {
      if (expandTermsText) {
        document.dispatchEvent(new CustomEvent('terms:modal:openAndExpanded'));

      } else {
        document.dispatchEvent(new CustomEvent('terms:modal:open'));
      }
    }
  };

  await validate();
};